import React, { useEffect, useRef, useState } from "react";

const PaymentInfo = (props) => {
  const infoForm = useRef(null);
  const [paymentMetrics, setPaymentMetrics] = useState({});
  const [timeline, setTimeline] = useState("TODAY");
  const revenueInfoCardData = [
    {
      title: "Total Payment",
      count: paymentMetrics?.totalPayouts?.count || 0,
      amount: paymentMetrics?.totalPayouts?.amount || 0,
      icon: imagepaths.moneyBagIcon,
    },
    // {
    //   title: "Pending Payment",
    //   count: paymentMetrics?.totalPendingPayouts?.count || 0,
    //   amount: paymentMetrics?.totalPendingPayouts?.amount || 0,
    //   icon: imagepaths.moneyBagIcon,
    // },
    {
      title: "Processed Payment",
      count: paymentMetrics?.totalProcessedPayout?.count || 0,
      amount: paymentMetrics?.totalProcessedPayout?.amount || 0,
      icon: imagepaths.moneyBagIcon,
    },
    {
      title: "Paid Payment",
      count: paymentMetrics?.totalPaidPayouts?.count || 0,
      amount: paymentMetrics?.totalPaidPayouts?.amount || 0,
      icon: imagepaths.moneyBagIcon,
    },
  ];
  // PAYMENT INFO

  const getPortfolioMetricsPayment = (query, params) => {
    let payload = {};
    if (params) {
      payload = {
        ...query,
        timeline: params,
      };
    } else {
      payload = {
        ...query,
        timeline: timeline,
      };
    }
    props.apis.apiGetPayoutStatusBreakdown(payload).then((res) => {
      let totalPaidPayoutsAmnt =
        Number(
          res?.data?.find(
            (item) => item.connector_payout_status === "PROCESSED"
          )?.total_net_connector_payout_amt || 0
        ) +
        Number(
          res?.data?.find((item) => item.connector_payout_status === "PAID")
            ?.total_net_connector_payout_amt || 0
        );

      let totalPaidPayoutsCount =
        Number(
          res?.data?.find(
            (item) => item.connector_payout_status === "PROCESSED"
          )?.total_count || 0
        ) +
        Number(
          res?.data?.find((item) => item.connector_payout_status === "PAID")
            ?.total_count || 0
        );

      setPaymentMetrics({
        totalPayouts: {
          amount: totalPaidPayoutsAmnt || 0,
          count: totalPaidPayoutsCount || 0,
        },
        totalPendingPayouts: {
          amount:
            res?.connector_payout_status_breakdown?.find(
              (item) => item.connector_payout_status === "PENDING"
            )?.total_net_connector_payout_amt || 0,
          count:
            res?.connector_payout_status_breakdown?.find(
              (item) => item.connector_payout_status === "PENDING"
            )?.total_count || 0,
        },
        totalProcessedPayout: {
          amount:
            res?.data?.find(
              (item) => item.connector_payout_status === "PROCESSED"
            )?.total_net_connector_payout_amt || 0,
          count:
            res?.data?.find(
              (item) => item.connector_payout_status === "PROCESSED"
            )?.total_count || 0,
        },
        totalPaidPayouts: {
          amount:
            res?.data?.find((item) => item.connector_payout_status === "PAID")
              ?.total_net_connector_payout_amt || 0,
          count:
            res?.data?.find((item) => item.connector_payout_status === "PAID")
              ?.total_count || 0,
        },
      });
    });
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
        }
      });
    }
  };

  const handleDateChange = (value) => {
    let val = value[0]?.key || "TODAY";
    let inputs = [
      "paymentinfo-column-start_date",
      "paymentinfo-column-end_date",
      "paymentinfo-column-search_btn",
      "paymentinfo-column-reset_btn",
    ];
    if (val === "CUSTOM") {
      showInputs(inputs);
      setPaymentMetrics({});
    } else {
      hideInputs(inputs);
      setTimeline(val);
    }
  };

  const onSearch = () => {
    let data = infoForm.current.form.current.getData();
    let queryData = {
      start_date: new Date(data?.start_date).toISOString(),
      end_date: new Date(data?.end_date).toISOString(),
    };
    getPortfolioMetricsPayment(queryData, "CUSTOM");
  };

  const resetSearchForm = () => {
    infoForm?.current?.form?.current?.reset();
    let inputs = [
      "paymentinfo-column-start_date",
      "paymentinfo-column-end_date",
      "paymentinfo-column-search_btn",
      "paymentinfo-column-reset_btn",
    ];
    hideInputs(inputs);
    getPortfolioMetricsPayment({}, "TODAY");
  };

  useEffect(() => {
    getPortfolioMetricsPayment();
  }, [timeline]);

  props.$setNode({
    props,
  });
  return (
    <>
      <div className="mb-4 dashboard_form_box">
        <h2 className="fs-4 mt-2 float-left">Payment Info.</h2>
        <div className="form_outer">
          <AppForm
            ref={infoForm}
            onSubmit={(...args) => onSearch(...args)}
            className="row justify-content-end"
          >
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2"
              id="column-timeline"
            >
              <AppInputFocus
                type="select"
                name="timeline"
                label="Time Line"
                options={_enum.OVERALL_DETAIL}
                onChange={(...args) => handleDateChange(...args)}
                defaultValue={"TODAY"}
                placeholder="Time Line"
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="paymentinfo-column-start_date"
            >
              <AppInputFocus
                type="date"
                name="start_date"
                label="Start Date"
                placeholder="Start Date"
                required={true}
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="paymentinfo-column-end_date"
            >
              <AppInputFocus
                type="date"
                name="end_date"
                label="End Date"
                placeholder="End Date"
                required={true}
              ></AppInputFocus>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="paymentinfo-column-search_btn"
            >
              <button type="submit" className="btn btn-primary search_btn">
                <i className="fa fa-search"></i>
                <span>Search</span>
              </button>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="paymentinfo-column-reset_btn"
            >
              <button
                type="button"
                className="btn btn-primary search_btn"
                onClick={(...args) => resetSearchForm(...args)}
              >
                <i class="fa-solid fa-filter-circle-xmark"></i>
                <span>Reset</span>
              </button>
            </div>
          </AppForm>
        </div>
        <div className="row pt-0">
          {revenueInfoCardData &&
            revenueInfoCardData.map((revenue) => {
              return (
                <>
                  <div
                    className="col-xl-3 col-sm-6"
                    // onClick={(...args) => navigate(revenue?.path)}
                  >
                    <div className="card dashboard_card application_card revenue_info_card">
                      <div className="card-body">
                        <div className="content">
                          <p className="card_label">{revenue?.title}</p>
                          <p className="count">{revenue?.amount?.curLakhs()}</p>
                          <p>Count : {revenue?.count}</p>
                        </div>
                        <div className="icon_container">
                          {/* <div className="icon">
                            <img src={revenue?.icon} alt="icon image" />
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default constore(PaymentInfo);
